import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------ *\
    #BUTTON
\* ------------------------------------ */
/** 
 * Actual button component wrapper adding display for taking full height of the content
 */
:host {
  display: inline-flex;
}

/**
 * Default button
 */
.cat-c-button {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: var(--cat-button-text-align, center);
  padding: var(--cat-button-padding, calc(var(--size-base-unit) * 1.125) var(--cat-space-medium));
  margin: 0;
  background-color: var(--cat-theme-color-button-background);
  border-width: var(--cat-theme-border-width);
  border-style: solid;
  border-color: var(--cat-theme-color-button-border);
  border-start-start-radius: var(--cat-button-border-block-start-left-radius, var(--cat-theme-border-radius));
  border-start-end-radius: var(--cat-button-border-block-start-right-radius, var(--cat-theme-border-radius));
  border-end-end-radius: var(--cat-button-border-block-end-right-radius, var(--cat-theme-border-radius));
  border-end-start-radius: var(--cat-button-border-block-end-left-radius, var(--cat-theme-border-radius));
  color: var(--cat-theme-color-button-content);
  width: var(--cat-theme-button-width, auto);
  text-decoration: none;
  cursor: pointer;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-button:hover {
  background-color: var(--cat-theme-color-button-background-hover);
  border-color: var(--cat-theme-color-button-border-hover);
  color: var(--cat-theme-color-button-content-hover);
}
.cat-c-button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  border-radius: var(--cat-theme-border-radius);
}
.cat-c-button:active {
  background-color: var(--cat-theme-color-button-background-active);
  border-color: var(--cat-theme-color-button-border-active);
  color: var(--cat-theme-color-button-content-active);
}
.cat-c-button[disabled], .cat-c-button[data-disabled] {
  background-color: var(--cat-theme-color-background-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}
.cat-c-button[disabled] ::slotted(a), .cat-c-button[data-disabled] ::slotted(a) {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}
.cat-c-button.cat-c-button--inline {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  padding: var(--cat-button-padding, 0);
  border: none;
  text-decoration: underline;
}

/**
 *  slotted custom link
 */
.cat-c-button ::slotted(a) {
  color: var(--cat-theme-color-button-content);
  text-decoration: none;
  cursor: pointer;
}

/**
 * Primary button
 * The icon button shares the styles of the standard primary button
 */
.cat-c-button--primary,
.cat-c-button--icon-only.cat-c-button--primary {
  background-color: var(--cat-theme-color-button-primary-background);
  border-color: var(--cat-theme-color-button-primary-border);
  color: var(--cat-theme-color-button-primary-content);
}
.cat-c-button--primary:hover,
.cat-c-button--icon-only.cat-c-button--primary:hover {
  background-color: var(--cat-theme-color-button-primary-background-hover);
  border-color: var(--cat-theme-color-button-primary-border-hover);
  color: var(--cat-theme-color-button-primary-content-hover);
}
.cat-c-button--primary:active,
.cat-c-button--icon-only.cat-c-button--primary:active {
  background-color: var(--cat-theme-color-button-primary-background-active);
  border-color: var(--cat-theme-color-button-primary-border-active);
  color: var(--cat-theme-color-button-primary-content-active);
}
.cat-c-button--primary[disabled], .cat-c-button--primary[data-disabled],
.cat-c-button--icon-only.cat-c-button--primary[disabled],
.cat-c-button--icon-only.cat-c-button--primary[data-disabled] {
  background-color: var(--cat-theme-color-button-primary-background-disabled);
  border-color: var(--cat-theme-color-button-primary-border-disabled);
  color: var(--cat-theme-color-button-primary-content-disabled);
}
.cat-c-button--primary[disabled] ::slotted(a), .cat-c-button--primary[data-disabled] ::slotted(a),
.cat-c-button--icon-only.cat-c-button--primary[disabled] ::slotted(a),
.cat-c-button--icon-only.cat-c-button--primary[data-disabled] ::slotted(a) {
  color: var(--cat-theme-color-button-primary-content-disabled);
  cursor: not-allowed;
}

/**
 * Contrast button
 */
.cat-c-button--contrast {
  background-color: var(--cat-theme-color-button-contrast-background);
  border-color: var(--cat-theme-color-button-contrast-border);
  color: var(--cat-theme-color-button-contrast-content);
}
.cat-c-button--contrast:hover {
  background-color: var(--cat-theme-color-button-contrast-background-hover);
  border-color: var(--cat-theme-color-button-contrast-border-hover);
  color: var(--cat-theme-color-button-contrast-content-hover);
}
.cat-c-button--contrast:active {
  background-color: var(--cat-theme-color-button-contrast-background-active);
  border-color: var(--cat-theme-color-button-contrast-border-active);
  color: var(--cat-theme-color-button-contrast-content-active);
}
.cat-c-button--contrast[disabled], .cat-c-button--contrast[data-disabled] {
  background-color: var(--cat-theme-color-button-contrast-background-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-button-contrast-content-disabled);
}
.cat-c-button--contrast[disabled] ::slotted(a), .cat-c-button--contrast[data-disabled] ::slotted(a) {
  color: var(--cat-theme-color-button-contrast-content-disabled);
  cursor: not-allowed;
}
.cat-c-button--contrast ::slotted(a) {
  color: var(--cat-theme-color-button-contrast-content);
}

/**
 * Ghost button
 */
.cat-c-button--ghost {
  background-color: var(--cat-theme-color-button-link-background);
  border-color: var(--cat-theme-color-button-link-border);
  color: var(--cat-theme-color-button-link-content);
}
.cat-c-button--ghost:hover {
  color: var(--cat-theme-color-button-link-content-hover);
  background-color: var(--cat-theme-color-button-link-background-hover);
  border-color: var(--cat-theme-color-button-link-border-hover);
}
.cat-c-button--ghost:active {
  background-color: var(--cat-theme-color-button-link-background-active);
  border-color: var(--cat-theme-color-button-link-border-active);
  color: var(--cat-theme-color-button-link-content-active);
}
.cat-c-button--ghost:focus-visible {
  color: var(--cat-theme-color-button-link-content);
  background-color: var(--cat-theme-color-button-link-background-hover);
  border-color: var(--cat-theme-color-button-link-border-hover);
}
.cat-c-button--ghost:focus-visible:hover {
  color: var(--cat-theme-color-button-link-content-hover);
}
.cat-c-button--ghost:focus-visible:active {
  color: var(--cat-theme-color-button-link-content-active);
}
.cat-c-button--ghost[disabled], .cat-c-button--ghost[data-disabled] {
  background-color: var(--cat-theme-color-button-link-background-disabled);
  border-color: var(--cat-theme-color-button-link-border-disabled);
  color: var(--cat-theme-color-button-link-content-disabled);
}
.cat-c-button--ghost[disabled] ::slotted(a), .cat-c-button--ghost[data-disabled] ::slotted(a) {
  color: var(--cat-theme-color-button-link-content-disabled);
  cursor: not-allowed;
}
.cat-c-button--ghost ::slotted(a) {
  color: var(--cat-theme-color-button-link-content);
}

/**
 * Inline button
 */
.cat-c-button--inline {
  background-color: var(--cat-theme-color-button-link-background);
  border-color: var(--cat-theme-color-button-link-border);
  color: var(--cat-theme-color-button-link-content);
}
.cat-c-button--inline:hover {
  background-color: var(--cat-theme-color-button-link-background-hover);
  border-color: var(--cat-theme-color-button-link-border-hover);
  color: var(--cat-theme-color-button-link-content-hover);
}
.cat-c-button--inline:active {
  background-color: var(--cat-theme-color-button-link-background-active);
  border-color: var(--cat-theme-color-button-link-border-active);
  color: var(--cat-theme-color-button-link-content-active);
}
.cat-c-button--inline[disabled], .cat-c-button--inline[data-disabled] {
  background-color: var(--cat-theme-color-button-link-background-disabled);
  border-color: var(--cat-theme-color-button-link-border-disabled);
  color: var(--cat-theme-color-button-link-content-disabled);
}
.cat-c-button--inline[disabled] ::slotted(a), .cat-c-button--inline[data-disabled] ::slotted(a) {
  color: var(--cat-theme-color-button-link-content-disabled);
  cursor: not-allowed;
}
.cat-c-button--inline ::slotted(a) {
  color: var(--cat-theme-color-button-link-content);
}

/**
 * Ghost Danger button
 */
.cat-c-button--ghost-danger {
  background-color: var(--cat-theme-color-button-ghost-danger-background);
  border-color: var(--cat-theme-color-button-ghost-danger-border);
  color: var(--cat-theme-color-button-ghost-danger-content);
}
.cat-c-button--ghost-danger:hover {
  background-color: var(--cat-theme-color-button-ghost-danger-background-hover);
  border-color: var(--cat-theme-color-button-ghost-danger-border-hover);
  color: var(--cat-theme-color-button-ghost-danger-content-hover);
}
.cat-c-button--ghost-danger:active {
  background-color: var(--cat-theme-color-button-ghost-danger-background-active);
  border-color: var(--cat-theme-color-button-ghost-danger-border-active);
  color: var(--cat-theme-color-button-ghost-danger-content-active);
}
.cat-c-button--ghost-danger[disabled], .cat-c-button--ghost-danger[data-disabled] {
  background-color: var(--cat-theme-color-button-ghost-danger-background-disabled);
  border-color: var(--cat-theme-color-button-ghost-danger-border-disabled);
  color: var(--cat-theme-color-button-ghost-danger-content-disabled);
}
.cat-c-button--ghost-danger[disabled] ::slotted(a), .cat-c-button--ghost-danger[data-disabled] ::slotted(a) {
  color: var(--cat-theme-color-button-ghost-danger-content-disabled);
  cursor: not-allowed;
}
.cat-c-button--ghost-danger ::slotted(a) {
  color: var(--cat-theme-color-button-ghost-danger-content);
}

/**
 * Danger button
 */
.cat-c-button--danger {
  background-color: var(--cat-theme-color-button-danger-background);
  color: var(--cat-theme-color-button-danger-content);
  border-color: var(--cat-theme-color-button-danger-border);
}
.cat-c-button--danger:hover {
  background-color: var(--cat-theme-color-button-danger-background-hover);
  border-color: var(--cat-theme-color-button-danger-border-hover);
  color: var(--cat-theme-color-button-danger-content-hover);
}
.cat-c-button--danger:active {
  background-color: var(--cat-theme-color-button-danger-background-active);
  border-color: var(--cat-theme-color-button-danger-border-active);
  color: var(--cat-theme-color-button-danger-content-active);
}
.cat-c-button--danger[disabled], .cat-c-button--danger[data-disabled] {
  background-color: var(--cat-theme-color-button-danger-background-disabled);
  border-color: var(--cat-theme-color-button-danger-border-disabled);
  color: var(--cat-theme-color-button-danger-content-disabled);
}
.cat-c-button--danger[disabled] ::slotted(a), .cat-c-button--danger[data-disabled] ::slotted(a) {
  color: var(--cat-theme-color-button-danger-content-disabled);
  cursor: not-allowed;
}
.cat-c-button--danger ::slotted(a) {
  color: var(--cat-theme-color-button-danger-content);
}

/**
 * Small button
 */
.cat-c-button--sm {
  padding: var(--cat-button-padding, calc(var(--size-base-unit) * 0.625) var(--cat-space-medium));
}
.cat-c-button--sm.cat-c-button--inline {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
}

/**
 * Large button
 */
.cat-c-button--lg {
  padding: calc(var(--size-base-unit) * 1.375) var(--cat-space-x-large);
  font-family: var(--cat-theme-typography-label-lg-font-family);
  font-weight: var(--cat-theme-typography-label-lg-font-weight);
  font-size: var(--cat-theme-typography-label-lg-font-size);
  line-height: var(--cat-theme-typography-label-lg-line-height);
}
.cat-c-button--lg.cat-c-button--inline {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
}

/**
 * Default button icon with no text (icon only)
 */
.cat-c-button--icon-only {
  background-color: var(--cat-theme-color-button-background);
  border-color: var(--cat-theme-color-button-border);
  color: var(--cat-theme-color-button-content);
}
.cat-c-button--icon-only:hover {
  background-color: var(--cat-theme-color-button-background-hover);
  border-color: var(--cat-theme-color-button-border-hover);
  color: var(--cat-theme-color-button-content-hover);
}
.cat-c-button--icon-only:active {
  background-color: var(--cat-theme-color-button-background-active);
  border-color: var(--cat-theme-color-button-border-active);
  color: var(--cat-theme-color-button-content-active);
}
.cat-c-button--icon-only[disabled] {
  background-color: var(--cat-theme-color-button-background-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-button-content-disabled);
}

/**
 * Bare button icon with no text (icon only)
 */
.cat-c-button--icon-only.cat-c-button--ghost {
  background-color: var(--cat-button--icon-only-ghost-default, transparent);
  border-color: transparent;
  color: var(--cat-theme-color-button-content);
}
.cat-c-button--icon-only.cat-c-button--ghost:hover {
  background-color: var(--cat-button-ghost-hover-background, var(--cat-theme-color-button-icon-default-background-hover));
  border-color: transparent;
  color: var(--cat-theme-color-button-content-hover);
}
.cat-c-button--icon-only.cat-c-button--ghost:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-button--icon-only.cat-c-button--ghost:active {
  background-color: var(--cat-button--icon-only-ghost-active, var(--cat-theme-color-button-icon-default-background-active));
  border-color: transparent;
  color: var(--cat-theme-color-button-content-active);
}
.cat-c-button--icon-only.cat-c-button--ghost[disabled] {
  background-color: var(--cat-button--icon-only-ghost-disabled, transparent);
  border-color: transparent;
  color: var(--cat-theme-color-button-content-disabled);
}

/**
 * Contrast button icon with no text (icon only)
 */
.cat-c-button--icon-only.cat-c-button--contrast {
  background-color: var(--cat-theme-color-button-contrast-background);
  color: var(--cat-theme-color-button-contrast-content);
  border-color: var(--cat-theme-color-button-contrast-border);
}
.cat-c-button--icon-only.cat-c-button--contrast:hover {
  background-color: var(--cat-theme-color-button-contrast-background-hover);
  border-color: var(--cat-theme-color-button-contrast-border-hover);
  color: var(--cat-theme-color-button-contrast-content-hover);
}
.cat-c-button--icon-only.cat-c-button--contrast:active {
  background-color: var(--cat-theme-color-button-contrast-background-active);
  border-color: var(--cat-theme-color-button-contrast-border-active);
  color: var(--cat-theme-color-button-contrast-content-active);
}
.cat-c-button--icon-only.cat-c-button--contrast[disabled] {
  background-color: var(--cat-theme-color-button-contrast-background-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-button-contrast-content-disabled);
}

/**
 * Danger button icon with no text (icon only)
 */
.cat-c-button--icon-only.cat-c-button--ghost-danger {
  background-color: transparent;
  color: var(--cat-theme-color-button-ghost-danger-content);
  border-color: transparent;
}
.cat-c-button--icon-only.cat-c-button--ghost-danger:hover {
  background-color: var(--cat-theme-color-button-icon-default-background);
  border-color: transparent;
  color: var(--cat-theme-color-button-ghost-danger-content-hover);
}
.cat-c-button--icon-only.cat-c-button--ghost-danger:active {
  background-color: var(--cat-theme-color-button-icon-default-background-active);
  border-color: transparent;
  color: var(--cat-theme-color-button-ghost-danger-content-hover);
}
.cat-c-button--icon-only.cat-c-button--ghost-danger[disabled] {
  background-color: transparent;
  border-color: transparent;
  color: var(--cat-theme-color-button-danger-background-disabled);
}

/**
 * Inverted button icon with no text (icon only)
 */
.cat-c-button--icon-only.cat-c-button--inverted {
  background: var(--cat-button-icon-only-inverted-default, transparent);
  border-color: transparent;
  color: var(--cat-theme-color-content-knockout);
}
.cat-c-button--icon-only.cat-c-button--inverted:hover, .cat-c-button--icon-only.cat-c-button--inverted:active {
  background: transparent;
  border-color: transparent;
  color: var(--cat-theme-color-content-knockout);
}
.cat-c-button--icon-only.cat-c-button--inverted:hover {
  background: var(--component-button-contrast-background-hover, var(--cat-theme-color-content-strong-hover));
}
.cat-c-button--icon-only.cat-c-button--inverted:active {
  background: var(--component-button-contrast-background-active, var(--cat-theme-color-background-strong));
}
.cat-c-button--icon-only.cat-c-button--inverted:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-button--icon-only.cat-c-button--inverted[disabled] {
  border-color: transparent;
  color: var(--cat-theme-color-border-default-hover);
  background: var(--cat-button-icon-only-inverted-disabled, transparent);
}

/** 
 * Extra small button for icon only
 */
.cat-c-button--icon-only.cat-c-button--xs {
  padding: var(--cat-button-padding, calc(var(--size-base-unit) * 0.625));
  --cat-icon-height: calc(var(--size-base-unit) * 1.5);
  --cat-icon-width: calc(var(--size-base-unit) * 1.5);
}

/** 
 * Small button for icon only
 */
.cat-c-button--icon-only.cat-c-button--sm {
  padding: var(--cat-button-padding, calc(var(--size-base-unit) * 0.875));
}

/**
* Medium button for icon only
*/
.cat-c-button--icon-only.cat-c-button--md {
  padding: var(--cat-button-padding, calc(var(--size-base-unit) * 1.375));
}

/**
 * Large button for icon only
 */
.cat-c-button--icon-only.cat-c-button--lg {
  padding: var(--cat-button-padding, calc(var(--size-base-unit) * 1.875));
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
}

/**
 * Icon within button
 */
::slotted(cat-icon) {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  display: block;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  transform: none;
}

/**
 * Button text directly after button icon
 */
.cat-c-button__before + .cat-c-button__text:not(.cat-u-is-vishidden) {
  margin-inline-start: var(--cat-space-x-small);
}

.cat-c-button--icon-top .cat-c-button__before + .cat-c-button__text {
  margin-inline-start: 0;
}

/**
 * Button icon directly after button text
 */
.cat-c-button__text:not(.cat-u-is-vishidden) + .cat-c-button__after {
  margin-inline-start: var(--cat-space-x-small);
}

/**
 * Full-width button
 */
:host([fullWidth]),
.cat-c-button--full-width {
  width: 100%;
  text-align: center;
}

/**
 * Stacked button found on PCC homepage and product card
 */
.cat-c-button--icon-top {
  flex-direction: column;
  text-align: center;
  padding: calc(var(--size-base-unit) * 1.875);
  width: calc(var(--size-base-unit) * 13);
}
.cat-c-button--icon-top .cat-c-button__before {
  width: calc(var(--size-base-unit) * 4);
  height: calc(var(--size-base-unit) * 4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.cat-c-button--icon-top .cat-c-button__text:not(.cat-u-is-vishidden) {
  font-family: var(--cat-theme-typography-footnote-bold-font-family);
  font-weight: var(--cat-theme-typography-footnote-bold-font-weight);
  font-size: var(--cat-theme-typography-footnote-bold-font-size);
  line-height: var(--cat-theme-typography-footnote-bold-line-height);
  display: block;
  margin-inline-start: 0;
  margin-block-start: var(--cat-space-x-small);
  min-height: calc(var(--size-base-unit) * 4);
}

.cat-c-button:not(.cat-c-button--has-before) .cat-c-button__before, .cat-c-button:not(.cat-c-button--has-after) .cat-c-button__after {
  display: none;
}
.cat-c-button:not(.cat-c-button--has-before) .cat-c-button__text {
  margin-inline-start: calc(var(--size-base-unit) * 0);
}
`;
       